import { FunctionComponent, useState } from 'react';
import GenericIcons from '../../components/generics/GenericIcons';
import { useNavigate } from 'react-router-dom';
import heroImg from '../../img/vdr-red-hero.jpg';
import wwdImgMapa from '../../img/vdr-tool-mapa.jpg';
import wwdImgDatos from '../../img/vdr-tool-datos.jpg';
import wwdImgCapacidad from '../../img/vdr-tool-capacidad.jpg';
import wwdImgConexion from '../../img/vdr-tool-conexion.jpg';
import wwdImgRobustos from '../../img/vdr-tool-robustos.jpg';
import wwdImgEstadisticas from '../../img/vdr-tool-estadisticas.jpg';
import iconMapa from '../../img/mapMarkedSolidLargeIcon.svg';
import iconDatos from '../../img/databaseSolidLargeIcon.svg';
import iconCapacidad from '../../img/LightbulbFilamentIcon.svg';
import iconConexion from '../../img/clipboardListSolidLargeIcon.svg';
import iconRobustos from '../../img/LightningIcon.svg';
import iconEstadisticas from '../../img/chartBarSolidLargeIcon.svg';
import '../../css/publicHomePage.css';

export const whatWeDoBtns: Array<{
  id: string;
  name: string;
  icon: string;
  image: string;
  title: string;
  description: string;
}> = [
  {
    id: '1',
    name: 'Mapa Interactivo de Redes',
    icon: 'mapMarkedSolidLargeIcon',
    image: 'home-what-we-do-1',
    title: 'Explora visualmente la infraestructura de las redes eléctricas de distribución',
    description:
      'A través de una interfaz interactiva e intuitiva. Además, accede a información detallada de alimentadores, líneas, transformadores y recursos energéticos distribuidos con tan solo un clic.'
  },
  {
    id: '2',
    name: 'Gestión de Datos de Redes',
    icon: 'databaseSolidLargeIcon',
    image: 'home-what-we-do-2',
    title: 'Carga datos de infraestructura y operación',
    description:
      'De las redes de eléctricas de distribución de tu empresa a una base de datos consolidada. Además, corrige errores de manera automática y genera reportes de calidad de tus datos.'
  },
  {
    id: '3',
    name: 'Capacidad de Alojamiento de Redes',
    icon: 'LightbulbFilamentIcon',
    image: 'home-what-we-do-3',
    title: 'Realiza estudios de capacidad de alojamiento',
    description:
      'De sistemas fotovoltaicos residenciales en alimentadores chilenos con una amplia gama de configuraciones. Además, considera medidas de mitigación como cambio de TAPs, control Volt-Var con inversores y baterías.'
  },
  {
    id: '4',
    name: 'Evaluación de Conexión de Proyectos',
    icon: 'clipboardListSolidLargeIcon',
    image: 'home-what-we-do-4',
    title: 'Evalúa el impacto de un proyecto PMGD',
    description:
      'En un alimentador seleccionado previamente. La metodología de evaluación está alineada con la normativa técnica vigente (NTCO).'
  },
  {
    id: '5',
    name: 'Puntos Robustos de Red',
    icon: 'LightningIcon',
    image: 'home-what-we-do-5',
    title: 'Para cada punto de conexión de interés',
    description:
      'Evalúa la máxima capacidad de inyección de un proyecto PMGD que no requiere de obras adicionales para cumplir con criterios de seguridad de la red establecidos en la normativa vigente.'
  },
  {
    id: '6',
    name: 'Estadísticas del Sector',
    icon: 'chartBarSolidLargeIcon',
    image: 'home-what-we-do-6',
    title: 'Accede a estadísticas generales del sector eléctrico',
    description:
      'Como capacidad instalada a nivel nacional u otra granularidad. Accede a resultados agregados de estudios de capacidad de alojamiento.'
  }
];

const FAQ: Array<{ id: string; question: string; answer: string }> = [
  {
    id: '1',
    question: '¿Qué beneficios ofrece la integración de recursos energéticos distribuidos?',
    answer:
      'La integración de recursos energéticos distribuidos ofrece varios beneficios, como la reducción de pérdidas en la red, mejora de la eficiencia energética, mayor resiliencia y flexibilidad de la red, disminución de costos operativos, y una menor dependencia de fuentes de energía centralizadas. Además, contribuye a la sostenibilidad ambiental al facilitar el uso de energías renovables.'
  },
  {
    id: '2',
    question: '¿Qué es la capacidad de alojamiento?',
    answer:
      'La capacidad de alojamiento es la cantidad máxima de recursos energéticos distribuidos (como paneles solares, baterías, etc.) que una red de distribución puede integrar sin realizar obras adicionales o cambios de operación y manteniendo su operación segura y confiable. Esta capacidad depende de factores como la infraestructura de la red, la demanda de energía y la ubicación de los recursos energéticos distribuidos.'
  },
  {
    id: '3',
    question: '¿Qué tipo de análisis realiza la plataforma VisiónDERRED?',
    answer:
      'VisiónDERRED permite la evaluación técnica expedita de la incorporación de recursos energéticos distribuidos en redes reales de media y baja tensión y de medidas de mitigación a eventuales problemas operacionales, a través de modelos eléctricos basados en datos de infraestructura y variables eléctricas medidas, la modelación avanzada de los recursos energéticos distribuidos y el uso de metodologías validadas a nivel internacional o establecidas en la normativa chilena.'
  },
  {
    id: '4',
    question: '¿Quién provee los datos para hacer los cálculos de capacidad?',
    answer:
      'Los datos son provistos por las empresas distribuidoras de energía eléctrica, que recopilan información sobre la infraestructura de la red, el consumo de energía, y la integración de recursos energéticos distribuidos. Además, se pueden utilizar datos de sensores y medidores inteligentes instalados en diferentes puntos de la red con el fin de tener una mejor representación de las redes.'
  },
  {
    id: '5',
    question: '¿Cómo se garantiza la seguridad de los datos en la plataforma?',
    answer:
      'La seguridad de los datos en la plataforma VisiónDERRED se garantiza mediante el uso de protocolos de cifrado avanzados, autenticación de usuarios, y controles de acceso. Además, se implementan medidas de seguridad cibernética basado en servicios en la nube para proteger los datos contra accesos no autorizados y posibles ciberataques.'
  }
];

// Imágenes de "Qué hacemos" por id de opción (solo presentación).
const whatWeDoImages: { [id: string]: string } = {
  '1': wwdImgMapa,
  '2': wwdImgDatos,
  '3': wwdImgCapacidad,
  '4': wwdImgConexion,
  '5': wwdImgRobustos,
  '6': wwdImgEstadisticas
};

// Los mismos íconos de la lista, usados como máscara para pintarlos con el color de marca.
const whatWeDoIcons: { [icon: string]: string } = {
  mapMarkedSolidLargeIcon: iconMapa,
  databaseSolidLargeIcon: iconDatos,
  LightbulbFilamentIcon: iconCapacidad,
  clipboardListSolidLargeIcon: iconConexion,
  LightningIcon: iconRobustos,
  chartBarSolidLargeIcon: iconEstadisticas
};

const PublicHomePage: FunctionComponent = () => {
  const navigate = useNavigate();

  const [faqActive, setFaqActive] = useState<string | undefined>(undefined);
  const [whatWeDoBtnActive, setWhatWeDoBtnActive] = useState('1');

  const goToLoginPage = () => navigate('/public/login');
  const goToMapPage = () => navigate('/public/ver-mapa');
  const goToWhatWeDoPage = () => navigate('/public/que-hacemos');

  return (
    <div className='public-home-page-container'>
      <div className='public-home-page-content-container vdr-home-hero'>
        {/* 1 */}
        <div className='public-home-page-3-7-column public-home-page-description-container vdr-home-hero-txt'>
          <span className='vdr-eyebrow vdr-eyebrow--bar vdr-eyebrow--on-dark vdr-home-kicker'>
            Plataforma web · Proyecto Fondef IDeA I+D
          </span>
          <h2 className='public-home-page-description-title'>
            Plataforma para la Integración de{' '}
            <span className='vdr-home-title-accent'>Recursos Energéticos Distribuidos</span>
          </h2>
          <div className='public-home-page-home-img-container-mobile'>
            <img className='vdr-home-hero-img-el' src={heroImg} alt='' />
          </div>
          <p className='public-home-page-description-details'>
            ¡Hola! Somos VisiónDERRED. Te ayudamos en el proceso de conexión de tu proyecto de
            generación distribuida, desde encontrar un buen lugar para tu proyecto, hasta
            desarrollar los análisis y estudios que requiere la regulación vigente en cada caso.
            También apoyamos a empresas y el estado en análisis global de redes para una mejor
            planificación y regulación de las mismas. Calculamos lo que se te ocurra en redes de
            distribución ;)
          </p>
          <div className='public-home-page-explore-map-btn-container'>
            <button
              className='primary-button-style public-home-page-explore-map-btn'
              onClick={goToMapPage}>
              Explorar mapa
              <span className='vdr-home-arrow' aria-hidden='true'>
                →
              </span>
            </button>
          </div>
        </div>
        <div className='public-home-page-7-11-column public-home-page-home-img-container public-home-page-home-img-container-desktop vdr-home-hero-media'>
          <img className='vdr-home-hero-img-el' src={heroImg} alt='' />
          <span className='vdr-caption vdr-home-cap' aria-hidden='true'>
            Red de distribución · oriente de Santiago
          </span>
        </div>
      </div>
      <div className='public-home-page-content-container public-home-page-content-container-cyan vdr-home-section'>
        {/* 2 */}
        <div className='public-home-page-3-11-column vdr-section-head vdr-home-head'>
          <h2 className='public-home-page-subtitle'>Qué hacemos</h2>
          <small aria-hidden='true'>Herramientas</small>
        </div>
        <div className='public-home-page-3-11-column public-home-page-what-we-do-container'>
          <div className='public-home-page-what-we-do-button-container'>
            {whatWeDoBtns.map((btn, idx) => (
              <button
                key={`public-home-page-what-we-do-btn-key-${idx}`}
                className={`interactive-button vdr-home-option ${
                  btn.id === whatWeDoBtnActive ? 'interactive-button-active' : ''
                }`}
                onClick={() => setWhatWeDoBtnActive(btn.id)}>
                <span className='vdr-home-option-num' aria-hidden='true'>
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span
                  className='vdr-home-option-icon'
                  aria-hidden='true'
                  style={{
                    WebkitMaskImage: `url(${whatWeDoIcons[btn.icon]})`,
                    maskImage: `url(${whatWeDoIcons[btn.icon]})`
                  }}
                />
                <span className='vdr-home-option-label'>{btn.name}</span>
                <span className='vdr-home-option-arrow' aria-hidden='true'>
                  →
                </span>
              </button>
            ))}
          </div>
          <div className='public-home-page-what-we-do-content'>
            <div className='public-home-page-what-we-do-description-container'>
              <div className='public-home-page-what-we-do-img-container'>
                <img
                  className='vdr-home-detail-img'
                  src={whatWeDoImages[whatWeDoBtnActive]}
                  alt=''
                />
                <span className='vdr-caption vdr-home-cap' aria-hidden='true'>
                  {whatWeDoBtns.find((btn) => btn.id === whatWeDoBtnActive)?.name}
                </span>
              </div>
              <div className='vdr-home-detail-body'>
                <span className='vdr-eyebrow vdr-home-detail-index' aria-hidden='true'>
                  {`${whatWeDoBtnActive.padStart(2, '0')} / ${String(
                    whatWeDoBtns.length
                  ).padStart(2, '0')}`}
                </span>
                <h2 className='public-home-page-what-we-do-title'>
                  {whatWeDoBtns.find((btn) => btn.id === whatWeDoBtnActive)?.title}
                </h2>
                <p className='public-home-page-what-we-do-description'>
                  {whatWeDoBtns.find((btn) => btn.id === whatWeDoBtnActive)?.description}
                </p>
              </div>
            </div>

            <div className='public-home-page-what-we-do-img-bottom-buttons-container'>
              <button className='primary-button-style' onClick={goToLoginPage}>
                Explorar herramienta
                <span className='vdr-home-arrow' aria-hidden='true'>
                  →
                </span>
              </button>
              <button className='secondary-button-style' onClick={goToWhatWeDoPage}>
                Conocer más
              </button>
            </div>
          </div>
        </div>
        {/* what we do mobile */}
        {whatWeDoBtns.map((btn, idx) => (
          <div
            key={`public-home-page-what-we-do-mobile-key-${idx}`}
            className='public-home-page-what-we-do-mobile-container'>
            <div className='vdr-home-mobile-media'>
              <img src={whatWeDoImages[btn.id]} alt='' />
              <span className='vdr-caption vdr-home-cap' aria-hidden='true'>
                {`${String(idx + 1).padStart(2, '0')} · ${btn.name}`}
              </span>
            </div>
            <h3 className='public-home-page-what-we-do-title'>{btn.title}</h3>
            <p className='public-home-page-what-we-do-description'>{btn.description}</p>
            <div className='public-home-page-what-we-do-img-bottom-buttons-container'>
              <button className='primary-button-style' onClick={goToLoginPage}>
                Explorar herramienta
              </button>
              <button className='secondary-button-style' onClick={goToWhatWeDoPage}>
                Conocer más
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className='public-home-page-content-container vdr-home-section'>
        {/* 3 */}
        <div className='public-home-page-3-11-column'>
          <div className='vdr-section-head vdr-home-head'>
            <h2 className='public-home-page-subtitle public-home-page-faq-title'>
              Preguntas Frecuentes
            </h2>
            <small aria-hidden='true'>Ayuda</small>
          </div>
          <div className='public-home-page-faq-container'>
            {FAQ.map((item, idx) => (
              <div
                key={`public-home-page-faq-item-key-${idx}`}
                className={`public-home-page-faq-item ${
                  faqActive === item.id ? 'public-home-page-faq-item-active' : ''
                }`}>
                <h2 className='vdr-home-faq-heading'>
                  <button
                    type='button'
                    className='public-home-page-faq-item-question-container'
                    aria-expanded={faqActive === item.id}
                    aria-controls={`vdr-home-faq-answer-${item.id}`}
                    onClick={() => setFaqActive((prev) => (prev === item.id ? undefined : item.id))}>
                    <span className='vdr-home-faq-question'>{item.question}</span>
                    <GenericIcons
                      className='vdr-home-faq-chevron'
                      icon='chevronDownIcon'
                      imageStyle={faqActive === item.id ? {} : { transform: 'rotate(-90deg)' }}
                    />
                  </button>
                </h2>
                <p
                  id={`vdr-home-faq-answer-${item.id}`}
                  className={`public-home-page-faq-item-answer ${
                    faqActive === item.id
                      ? 'public-home-page-faq-item-answer-active'
                      : 'public-home-page-faq-item-answer-disabled'
                  }`}>
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Franja final, como la de la ficha del proyecto en centra.uai.cl */}
      <div className='vdr-home-cta'>
        <h2 className='vdr-home-cta-title'>Explora la red de distribución</h2>
        <button className='primary-button-style vdr-home-cta-btn' onClick={goToMapPage}>
          Explorar mapa
          <span className='vdr-home-arrow' aria-hidden='true'>
            →
          </span>
        </button>
      </div>
    </div>
  );
};

export default PublicHomePage;
